import React, { useState } from "react"
import pluralize from "pluralize"
import { Typography } from "antd"

import Modal from "../reusable/modal"

import { parseInstructions } from "../../modules"

let { Paragraph } = Typography

const EditPrescription = ({ prescription, visible, toggle, onPerform }) => {
    const [ds, freq, dys] = parseInstructions(prescription?.instructions)

    const [dosage, setDosage] = useState(ds)
    const [frequency, setFrequency] = useState(freq)
    const [days, setDays] = useState(dys)
    const [quantity, setQuantity] = useState(prescription.quantity ?? 1)

    let specials = ['Gels', 'Syrups', 'Suspensions', 'Ointments', 'Drops']

    const editPrescription = () => {
        prescription.dosage = dosage
        prescription.frequency = frequency
        prescription.days = days
        prescription.quantity = quantity
        prescription.instructions = `${dosage} x ${frequency} for ${days} ${pluralize('day', days)}`

        onPerform(prescription)
        setTimeout(toggle, 300)
    }

    const modify = e => {
        let ds = dosage, f = frequency, d = days

        switch (e.target.name) {
            case 'dosage':
                ds = e.target.value
                setDosage(e.target.value)
                break

            case 'frequency':
                f = e.target.value
                setFrequency(e.target.value)
                break

            case 'days':
                d = e.target.value
                setDays(e.target.value)
                break

            case 'quantity':
                setQuantity(e.target.value)
                break
    
            default:
                break
        }

        if (!specials.includes(prescription.category)) {
            setQuantity((ds * f * d) ?? 0)
        }
    }
    
    return (
        <Modal
            w={ 400 }
            title="Edit Prescription"
            toggle={toggle}
            visible={visible}>       
            <div className="flex flex-wrap mt-3 mb-6">
                <div className="w-full px-3 mb-6 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Dosage
                    </label>
                    <input
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-dosage"
                        type="number"
                        name="dosage"
                        value={ dosage }
                        onChange={ modify }
                        placeholder="100" />
                </div>
                <div className="w-full px-3 mb-6 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Frequency
                    </label>
                    <input
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-frequency"
                        type="number"
                        name="frequency"
                        value={ frequency }
                        onChange={ modify }
                        placeholder="100" />
                </div>
                <div className="w-full px-3 mb-6 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Number of Days
                    </label>
                    <input
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-days"
                        type="number"
                        name="days"
                        value={ days }
                        onChange={ modify }
                        placeholder="100" />
                </div>
                <div className="w-full px-3 mb-6 md:mb-0">
                    <div className="flex">Quantity: <Paragraph editable={{ onChange: val => setQuantity(val ?? quantity ?? 1) }}>{ quantity }</Paragraph> { pluralize(prescription?.ref?.issuedIn ?? '', quantity ?? 0) }</div>
                </div>
            </div>
            <div className="flex justify-end">
                <button onClick={ editPrescription } className="text-white hisani-btn-green-light font-medium rounded-lg text-sm px-5 py-2.5 text-center">Prescribe { quantity * (prescription?.conversionRate ?? 1) } { pluralize(prescription?.ref?.issuedIn ?? '', (quantity * (prescription?.conversionRate ?? 1)) ?? 0) }</button>
            </div>
        </Modal>
    )
}   

export default EditPrescription